import {createRouter, createWebHistory} from "vue-router"
import Home from "./views/Home.vue"
import RecipeDetail from "./views/RecipeDetail.vue"
import PrivacyPolicy from "./views/PrivacyPolicy.vue"
import ResetPassword from "./views/ResetPassword.vue"
import { SERVICE_PATH } from "./services/http-client.js"
export const router=createRouter({
    history: createWebHistory(),
    routes:[
        {path:`${SERVICE_PATH}`, name:"Home", component: Home},
        {path:`${SERVICE_PATH}/recipe/:id`, name:"RecipeDetail", component: RecipeDetail},
        {path:`${SERVICE_PATH}/policy`, name:"PrivacyPolicy", component: PrivacyPolicy},
        {path:`${SERVICE_PATH}/reset-password`, name:"ResetPassword", component: ResetPassword},
    ],
})